module.exports = __webpack_public_path__ + "img/linkedin.a073ecdf.png";